'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-switch@1.5.2@rc-switch/lib/index.js
// module id = 741
// module chunks = 0 1